var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavourits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57254,3.03646H3.066V17.1327H8.81825a.50523.50523,0,1,1,0,1.00687H2.51816a.527.527,0,0,1-.54783-.50343V2.533a.527.527,0,0,1,.54783-.50344H18.13142a.527.527,0,0,1,.54783.50344V8.32255a.54979.54979,0,0,1-1.09566,0V3.03646H16.077v2.1396h-1.6435V3.03646H12.79v2.1396h-1.6435V3.03646H9.503v2.1396H7.85954V3.03646H6.21686v2.1396H4.57254ZM15.355,9.51765l2.06345,4.11857,4.61119.66039-3.33642,3.2061.78688,4.52687L15.355,19.89219l-4.1233,2.13739.78688-4.52687-3.33732-3.2061,4.61209-.66039Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourits);
export default __webpack_public_path__ + "static/media/favourits.41cbdac7b88c6947be95953a3aa5dfe7.svg";
export { ForwardRef as ReactComponent };